module.exports = ''
+ '<div class="creek-shows-container">'
+ '  <creek-shows-nav :shows-nav-text="showsNavText"></creek-shows-nav>'
+ '  <div class="creek-schedule-container" v-html="html">'
+ '  </div>'
// + '  <div v-if="!html" class="creek-schedule-container">'
// + '    '+Creek.data.router.loadingHtml
// + '  </div>'
+ '</div>'



// WEBPACK FOOTER //
// ./src/templates/page-shows-schedule.js